import type { InjectionToken } from 'tsyringe';
import { container } from './DpContainer';

export { container };

export function resolve<T>(token: InjectionToken<T>): T {
  return container.resolve(token);
}
